<template>
	<section class="starter-pc-hero-section" :style="{ 'background-image': `url(/images/section-images/backgrounds/ember/${slugTrackType}-bg.jpg)` }">
		<div class="container">
			<div class="row">
				<div class="col-md-6 col-sm-12">
					<div class="starter-pc-content affirm-promo">
						<h1 class="starter-pc-heading">{{ build.name }}</h1>
						<p class="starter-pc-sub">
							{{ heroTitle | stripTags }}
						</p>
						<div class="starter-pc-review" v-if="which != 'h1-mini-pc'">
							<star-rating
								:title="`Rating average: ${reviews.average_rating}`"
								:rating="reviews.average_rating"
								active-color="#FAA50B"
								inactive-color="#5F707F"
								:star-size="17"
								:show-rating="false"
								:increment="0.5"
								:border-width="1"
								border-color="transparent"
								:rounded-corners="false"
								:read-only="true"
								:star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
							/>
							<a @click.prevent="scrollToReviews" href="#" class="starter-pc-review-count">
								{{ reviewCount }} Reviews
							</a>
						</div>
						<model-picker
							v-if="totalBuilds > 1"
							:show-see-specs="true"
						/>
						<color-picker
							:show-see-specs="['streaming-pc', 'creator-pc', 'h1-mini-pc'].includes($route.name)"
							class="color-picker-hero"
							@see-specs="$emit('see-specs')"
						/>
						<!-- Temporarily removed due to oversold -->
						<!-- <add-streaming-bundle-button
                            v-if="$route.name == 'streaming-pc' && streamingBundle.id"
                            :show-see-bundle="true"
                            :accessory="streamingBundle"
                            type="streamingBundle"
                        /> -->
						<hard-drive-select
							v-if="['creator-pc', 'h1-mini-pc'].includes($route.name)"
							:show-see-more="true"
						/>
						<monitor-button
							v-if="$route.name != 'creator-pc'"
							:show-see-monitor="true"
						/>
						<p class="starter-pc-price">
							<span class="starter-pc-price-emphasis">
								<template v-if="['creator-pc', 'h1-mini-pc'].includes(which)">
									<promo-sales-timed class="promo-sales-price">
										<template v-slot:originalContent>
											{{ priceWithStorage | formatMoney(2) }}
										</template>
										<template>
											{{ promoDiscount(priceWithStorage) | formatMoney(2) }}
											<span class="discounted-price">{{ priceWithStorage | formatMoney(2) }}</span>
										</template>
									</promo-sales-timed>
								</template>
								<!-- <template v-else-if="which == 'streaming-pc'">
                                    {{ priceWithStreamingBundle | formatMoney(0) }}
                                </template> -->
								<template v-else-if="which == 'streaming-pc'">
									<promo-sales-timed class="promo-sales-price">
										<template v-slot:originalContent>
											{{ priceWithMonitor | formatMoney(2) }}
										</template>
										<template>
											{{ promoDiscount(build.price) | formatMoney(2) }}
											<span class="discounted-price">{{ build.price | formatMoney(2) }}</span>
										</template>
									</promo-sales-timed>
								</template>
								<template v-else>
									<promo-sales-timed class="promo-sales-price">
										<template v-slot:originalContent>
											{{ priceWithMonitor | formatMoney(2) }}
										</template>
										<template>
											{{ promoDiscount(priceWithMonitor) | formatMoney(2) }}
											<span class="discounted-price">{{ priceWithMonitor | formatMoney(2) }}</span>
										</template>
									</promo-sales-timed>
								</template>
								<span class="starter-pc-price-currency-code">USD</span>
							</span>
							<span class="starter-pc-price-ship" >
								<promo-sales-timed>
									<template v-slot:originalContent>
										{{ pageData[1].body | stripTags }}
									</template>
									<template slot-scope="{ phasesInfo: { currentPhase } }">
										<holiday-saving-msg
											v-if="which == 'streaming-pc'"
											:phase="currentPhase"
											text="streamingPC"
										/>
										<holiday-saving-msg
											v-else
											:phase="currentPhase"
											text="creatorAndH1PC"
										/>
									</template>
								</promo-sales-timed>
							</span>
						</p>
						<template>
							<sold-out-button v-if="isOutOfStock" />
							<div v-else>
								<div class="starter-pc__checkout">
									<button class="btn btn-pink" @click="$emit('buy-now', trackingOptions)">
										ADD TO CART
									</button>
								</div>
								<template v-if="!POS_MODE ">
									<paybright
										v-if="countryCode == 'CA'"
										ref="paybright"
										:price="financingPrice"
										class="affirm-starter-pc btn affirm-starter-pc-hero affirm-promo"
										@click="$emit('click-quoted-payment', trackingOptions.page_location)"
									/>
									<affirm
										v-else
										ref="affirm"
										:price="financingPrice"
										class="affirm-starter-pc btn affirm-starter-pc-hero affirm-promo"
										@click="$emit('click-quoted-payment', trackingOptions.page_location)"
									/>
								</template>
							</div>
						</template>
					</div>
				</div>
				<div class="col-md-6 col-sm-12 starter-pc-gallery">
					<pc-showcase v-if="pcGallery" />
				</div>
			</div>
		</div>
		<img src="/images/section-images/backgrounds/ember/sp-bg.jpg" style="display:none;">
		<img src="/images/section-images/backgrounds/ember/sp-plus-bg.jpg" style="display:none;">
	</section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Affirm from "@c/generals/affirm";
import ColorPicker from "./color-picker";
import ModelPicker from "./model-picker";
import Paybright from "@c/generals/paybright";
import PcShowcase from "./pc-showcase";
// import AddStreamingBundleButton from "./streaming-pc/add-streaming-bundle-button";
import HardDriveSelect from "./hard-drive-select";
import MonitorButton from "./monitor-button";
import SoldOutButton from "./soldout-button";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidaySavingMsg from "@c/generals/holiday-saving-msg";
import { promoDiscount } from "@u/helpers";

export default {
	name: "HeroSection",
	components: {
		PromoSalesTimed,
		HolidaySavingMsg,
		// AddStreamingBundleButton,
		Affirm,
		ColorPicker,
		HardDriveSelect,
		ModelPicker,
		MonitorButton,
		Paybright,
		PcShowcase,
		SoldOutButton
	},
	props: {
		which: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			trackingOptions: {
				page: "Product Page",
				page_location: "Top"
			}
		};
	},
	computed: {
		...mapState({
			build: state => state.StarterPc.builds[state.StarterPc.buildsIndex],
			cart: state => state.StarterPc.cart,
			countryCode: state => state.User.location.country_code,
			pageData: state => state.StarterPc.pageData.landing_page_sections,
			total: state => state.StarterPc.total,
			reviews: state => state.StarterPc.reviews,
			selectedMonitor: state => state.StarterPc.selectedMonitor[state.StarterPc.which],
			selectedStorage: state => state.StarterPc.selectedStorage,
			streamingBundle: state => state.StarterPc.accessories.streamingBundle[0] || {}
		}),
		...mapGetters({
			pcGallery: "StarterPc/pcGallery",
			totalBuilds: "StarterPc/totalBuilds",
			trackStarterType: "StarterPc/getTrackType",
			reviewCount: "StarterPc/reviewCount"
		}),
		financingPrice() {
			let price = this.priceWithMonitor;
			price = this.which == "h1-mini-pc" && this.priceWithStorage || price;
			price = this.which == "creator-pc" && this.priceWithStorage || price;
			price = this.which == "streaming-pc" && this.priceWithStreamingBundle || price;
			return price;
		},
		heroTitle() {
			return this.$route.name == "starter-pc-plus" ? this.pageData[9].body : this.pageData[0].body;
		},
		isOutOfStock() {
			const build = this.build.variants.find((variant) => {
				return variant.case_id == this.cart.case.id;
			});

			return build && build.stock == 0;
		},
		priceWithMonitor() {
			return Number(this.build.price) +
                (this.selectedMonitor && this.selectedMonitor.variants ? Number(this.selectedMonitor.variants[0].price) : 0);
		},
		priceWithStorage() {
			return Number(this.build.price) +
                (this.selectedStorage && this.selectedStorage.variants ? Number(this.selectedStorage.variants[0].price) : 0);
		},
		priceWithStreamingBundle() {
			return Number(this.build.price) +
                (this.cart.streamingBundle.id ? Number(this.cart.streamingBundle.price) : 0);
		},
		slugTrackType() {
			return this.trackStarterType == "Streaming PC" ? "sp" : this.trackStarterType.toLowerCase().replace(/ /g, "-");
		}
	},
	methods: {
		promoDiscount,
		scrollToReviews() {
			this.$scrollTo(document.querySelector(".reviews-heading"), 500, {
				offset: -88
			});
		}
	}
};
</script>

<style lang="scss">
.starter-pc-hero-section {
    .starter-pc-content {
        .starter-pc-review {
            .vue-star-rating-star {
                margin: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.starter-pc-hero-section {
    background-color: #370053;
    background-size: cover;
    color: $white;

    @media screen and (max-width: 991px) {
        background-position-y: center;
        background-position-x: center;

        .row {
            display: flex;
            flex-direction: column-reverse;
        }
    }

    .btn-pink {
        background-color: $orchid;
        padding: 18px 63px;
        width: 100%;
        text-align: center;
        color: $white;
        font-size: 14px;
        border: none;
        border-radius: 5px;
        transition: all 0.4s ease;

        @media (max-width: 580px) {
            display: block;
            margin: 0 auto;
            width: 100%;
            margin-bottom: 16px;
        }

        &:hover {
            background-color: $white;
            color: $orchid;
        }
    }

    .starter-pc-content {
        margin: 65px 0 90px;

        @media (min-width: 991px) {
            margin-left: 30px;
        }

        @media (max-width: 991px) {
            margin: 65px 0 50px;
        }

        @media (min-width: 580px) and (max-width: 991px) {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            max-width: 560px;
            margin: 0 auto 70px;
        }

        @media (max-width: 991px) {
            margin-top: 10px;
        }


        .starter-pc-heading {
            font-size: 48px;
            margin-bottom: 3px;

            @media (min-width: 580px) and (max-width: 991px) {
                width: 100%;
                font-size: 49px;
            }

            @media (min-width: 320px) and (max-width: 580px) {
                font-size: 32px;
                margin-top: 0;
            }
        }

        .starter-pc-sub {
            opacity: 0.7;
            font-size: 20px;

            @media (min-width: 580px) and (max-width: 991px) {
                width: 100%;
            }

            @media (min-width: 320px) and (max-width: 580px) {
                font-size: 16px;
                margin-bottom: 10px;
            }

            @media (max-width: 991px) {
                margin-bottom: 0;
            }
        }

        .starter-pc-review {
            display: flex;
            align-items: baseline;
            margin: 25px 0;

            @media (max-width: 580px) {
                margin: 20px 0;
            }

            &-count {
                color: $orchid;
                font-size: 16px;
                margin-left: 10px;

                &:hover {
                    color: darken($orchid, 10%);
                    text-decoration: underline;
                }
            }
        }

        .starter-pc-price {
            margin: 30px 0 10px;

            @media (min-width: 580px) and (max-width: 991px) {
                width: 100%;
                margin: 40px 0 0;
            }

            @media (max-width: 991px) {
                margin: 10px 0;
            }

            &-emphasis {
                color: $orchid;
                font-size: 24px;
                font-weight: bold;

                @media (min-width: 580px) and (max-width: 991px) {
                    font-size: 40px;
                }

                @media (min-width: 320px) and (max-width: 580px) {
                    font-size: 32px;
                }
            }

            &-currency-code {
                font-size: 14px;
                font-weight: 200;
                margin-left: -3px;

                @media (min-width: 580px) and (max-width: 991px) {
                    font-size: 16px;
                    margin-left: -6px;
                }
            }

            &-ship {
                display: block;

                @media (min-width: 580px) and (max-width: 991px) {
                    font-size: 18px;
                }

                @media (min-width: 320px) and (max-width: 580px) {
                    font-size: 14px;
                    padding-right: 30px;
                    line-height: 18px;
                }
            }
        }
    }

    .color-picker-hero {
        @media (min-width: 580px) and (max-width: 991px) {
            width: 100%;
        }
    }

    .starter-pc-gallery {
        margin-top: 30px;
    }

    .affirm-starter-pc-hero {
        margin-top: 5px;
        padding: 16px 25px;

        &:hover {
            color: $white;
        }

        &.affirm-promo {
            margin-top: 20px;
            padding: 6px 25px;
        }

        @media (max-width: 580px) {
            width: 100%;

            &.affirm-promo {
                margin-top: 4px;
            }
        }
    }

    .starter-pc__checkout {
        display: flex;
        @media only screen
        and (min-device-width : 768px)
        and (max-device-width : 1024px)
        and (orientation : portrait) {
            width: 100%;
        }
    }
}

.starter-pc-price::v-deep  {
	.holiday-savings-msg br {
		@media (min-width: 768px) {
			display: none;
		}
	}

	p {
		color: #fff;
	}

	.highlight {
		color: $orchid;
		font-weight: bold;
	}

	.discounted-price {
		text-decoration: line-through;
		font-size: 14px !important;
		margin: 0 !important;
	}

	.promo-sales-price {
		display: inline-block;
	}
}
</style>
